import { render, staticRenderFns } from "./BlogComments.vue?vue&type=template&id=fe610576&scoped=true&"
import script from "./BlogComments.vue?vue&type=script&lang=js&"
export * from "./BlogComments.vue?vue&type=script&lang=js&"
import style0 from "./BlogComments.vue?vue&type=style&index=0&id=fe610576&lang=scss&scoped=true&"
import style1 from "./BlogComments.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe610576",
  null
  
)

export default component.exports